import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer className="relative z-10 border-t border-white/10 bg-[#07080B]" data-testid="site-footer">
    <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-5 py-16 md:flex-row md:items-end md:justify-between md:px-10">
      <div className="flex items-center gap-4">
        <LogoMark className="h-12 w-12" />
        <div>
          <p className="font-brush text-3xl tracking-[0.25em] text-[#C81D25] ink-damage-sm">MINKA</p>
          <p className="font-mono-s text-xs uppercase tracking-[0.2em] text-[#A3ACBB]">A screenplay by Nicola Davis</p>
        </div>
      </div>
      <div className="flex flex-col gap-2 font-mono-s text-sm text-[#A3ACBB]">
        <a href="mailto:nini.laughlin@gmail.com" data-testid="footer-email-link" className="link-underline w-fit hover:text-[#E2E0D8]">nini.laughlin@gmail.com</a>
        <a href="tel:5056600596" data-testid="footer-phone-link" className="link-underline w-fit hover:text-[#E2E0D8]">505-660-0596</a>
        <Link to="/film-options" data-testid="footer-options-link" className="link-underline w-fit text-[#C81D25] hover:text-[#E76F51]">Film options & rights →</Link>
        <Link to="/admin" data-testid="footer-admin-link" className="w-fit text-xs text-[#A3ACBB]/60 hover:text-[#A3ACBB]">Owner login</Link>
      </div>
      <p className="font-mono-s text-xs text-[#A3ACBB]">© {new Date().getFullYear()} Nicola Davis. All rights reserved.</p>
    </div>
  </footer>
);
